import React from 'react';

export default function Slider(){
    return(
        <div className="slider-style">
         <p>Go & find Your Meal Today</p>
         <button type="button" class="btn btn-outline-success btn-lg">Explore !!</button>
        
        </div>
    )
}